












































































import Vue from "vue";
import EditCheckBox from "@/components/end_parts/EditCheckBox.vue";
import EditSelectionBox from "@/components/end_parts/EditSelectionBox.vue";

export default Vue.extend({
  components: {
    EditCheckBox,
    EditSelectionBox,
  },
  props: {
    parameterParam: {
      type: Object,
      default: Object,
    },
    parameterKey: {
      type: String,
      default: String,
    },
    inputCsvTransform: {
      type: String,
      default: String,
    },
    inputCsvHeader: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      JsonParam: Object,
      column: {
        padding: "10px 0px",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
    };
  },
  created() {
    this.JsonParam = this.parameterParam[this.parameterKey];
  },
  methods: {
    sendInputFile() {
      this.$emit("InputCSVEvent");
    },
    inputFileParameter(changeKey: string, changeBoolean: boolean) {
      this.$emit("sendInputFileParameter", changeKey, changeBoolean);
    },
  },
});
